import { useCallback } from 'react'
import { useAgentRuntime } from '../context/AgentProvider'

export type RuntimeEventEmitter<Detail = unknown> = (detail: Detail) => void

/**
 * Stable emitter for `runtime.events`.
 *
 * Returns a memoized function that dispatches a `CustomEvent` on the per-runtime
 * `EventTarget` so host apps can fire integration events.
 */
export const useRuntimeEventEmitter = <Detail = unknown>(type: string): RuntimeEventEmitter<Detail> => {
  const runtime = useAgentRuntime()

  const emit = useCallback(
    (detail: Detail) => {
      runtime.events.dispatchEvent(
        new CustomEvent(type, {
          detail
        })
      )
    },
    [runtime, type]
  )

  return emit
}

